import { Fragment, useEffect, useState } from "react"
import { getUserFormFields, usersFormSchema } from "./const"
import { useGetOrganisationsQuery } from "@store/services"
import { useLocation, useNavigate } from "react-router"
import { FormProvider, useForm } from "react-hook-form"
import { Box, Button, CircularProgress, Grid } from "@mui/material"
import { useCreateUserMutation } from "@store/services/usersService"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormBuilder } from "@components/FormBuilder"

export const AddUserForm = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const [userFormFields, setUserFormFields] = useState<any>(null)
  const { data: organisationsData } = useGetOrganisationsQuery({})
  const [allowedOrgDomains, setAllowedOrgDomains] = useState<string[]>([])
  const location = useLocation()
  const navigate = useNavigate()
  const orgId = location.state?.orgId
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const formMethods = useForm<any>({
    defaultValues: {
      active: true,
      key: "",
      first_name: "",
      last_name: "",
      organisation_key: "",
    },
    resolver: yupResolver(usersFormSchema(allowedOrgDomains)),
  })
  const [createUser, { data }] = useCreateUserMutation()
  const selectedOrg = formMethods.watch("organisation_key")

  useEffect(() => {
    if (organisationsData) {
      if (orgId) {
        const foundOrg = organisationsData?.items.find((x) => x.key == orgId)?.key

        formMethods.reset({
          organisation_key: foundOrg,
        })
      }

      setUserFormFields(
        getUserFormFields(
          organisationsData?.items.map((x) => ({
            id: x.key,
            value: x.key,
          })),
        ),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [organisationsData, orgId])

  useEffect(() => {
    if (selectedOrg) {
      const foundOrg = organisationsData?.items.find((x) => x.key == selectedOrg)
      setAllowedOrgDomains(
        // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
        foundOrg?.email_domains.map((x) => x.split("@")[1]) ?? [],
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [selectedOrg])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const onSubmit = (data: any) => {
    createUser(data)
  }

  const onCancelClick = () => navigate("/Administration/Users")

  useEffect(() => {
    if (data) {
      navigate(location.state?.from?.pathname ?? "/Administration/Users", {
        state: { openUsersSnackbar: true },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [data])

  return (
    <div>
      <h1>Add User Form</h1>
      {userFormFields ? (
        <FormProvider {...formMethods}>
          <form autoComplete={"off"} onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container={true} spacing={2} alignItems="center" sx={{ mb: 3 }}>
              {Object.keys(userFormFields).map((fieldName) => (
                <Fragment key={fieldName}>
                  <FormBuilder
                    field={fieldName}
                    component={userFormFields[fieldName]}
                    helperText={formMethods.formState.errors[fieldName]?.message as string}
                  />
                </Fragment>
              ))}
            </Grid>
            <Grid item={true} xs={12}>
              <Button variant="contained" type="submit">
                Add
              </Button>
              <Button
                sx={{ ml: 1 }}
                variant="contained"
                color={"error"}
                type="button"
                onClick={onCancelClick}
              >
                Cancel
              </Button>
            </Grid>
          </form>
        </FormProvider>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  )
}
